import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth/AuthSlice";
import modelReducer from "./model/slice";
import mediaReducer from "./customMedia/slice";
import galleryReducer from "./gallery/slice";
import instagramReducer from "./instagram/slice";
import xReducer from "./x/slice";
import youtubeReducer from "./youtube/slice";
import tikTokReducer from "./tikTok/slice";
import facebookReducer from "./facebook/slice";
import personaReducer from "./persona/slice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    model: modelReducer,
    media: mediaReducer,
    gallery: galleryReducer,
    instagram: instagramReducer,
    x: xReducer,
    youtube: youtubeReducer,
    tikTok: tikTokReducer,
    facebook: facebookReducer,
    persona: personaReducer,
  },
});
